<template>
  <div>
    <el-timeline class="order-detail-timeline">
      <el-timeline-item
        v-for="history in historyList"
        :key="history.Id"
        :timestamp="`${history.RecordUserName}(${history.RecordTypeName}) ${history.RecordTimeDisplay}`"
        placement="top"
      >
        <div class="timeline-content">
          <p>{{ history.RecordContent }}</p>
        </div>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "",
  props: {
    historyList: {
      default: [],
    },
  },
  data() {
    return {};
  },
  components: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.timeline-content {
    font-size: 14px;
    p {
        margin: 5px 0;
        word-break: break-all;
    }
    .el-timeline-item {
        padding-bottom: 5px;
    }
}
</style>
<style lang="scss">
.order-detail-timeline {
    .el-timeline-item {
        padding-bottom: 0px;
    }
}
</style>